export default __webpack_public_path__ + "static/media/Icon-Search.17c1fabd.svg";